import {h, Fragment} from "preact"
import { useAppStateSelector, pick } from "@nosto/preact";

export default function SearchHeader() {
    const { query } = useAppStateSelector(state =>
        pick(state, "query")
    )
    return (
        <div class="nosto__search-form-wrapper">
            <h2 class="nosto__search-form-title">
                Search results for "{query?.query}"
            </h2>
        </div>
    )
}